module.exports = __webpack_public_path__ + "static/img/1_0049.fe2f944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0049.jpg
// module id = BPVv
// module chunks = 0